/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {Row, Col, Box} from 'adminlte-2-react';
import {Alert} from '../utils/Alert';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import Loader from '../utils/Loader';
import {Content} from '../ui/Content';
import {UsuariosSelect} from './UsuariosSelect';
const {TextInput} = require('../utils/TextInput');

export const EquipoCreateView = ({
  mode,
  history,
  equipoGet,
  equipoCreate,
  submit,
  submitAlert,
  topAlert,
  nombre,
  setNombre,
  usuarios,
  setUsuarios,
  token,
}) => {
  const title = mode === 'edit' ? 'Editar equipo' : 'Crear equipo';

  return (
    <Content title={title} history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Loader isLoading={mode === 'edit' && equipoGet?.loading}>
        <Row>
          <Col md="10" mdOffset="1">
            <Box title="Datos del equipo">
              <Row>
                <Col md="12">
                  <Col md="4">
                    <TextInput
                      label="Nombre"
                      initialValue={nombre}
                      setValue={setNombre}
                      required
                    />
                  </Col>
                </Col>

                <Col md="12">
                  <Col md="4">
                    <UsuariosSelect
                      usuarios={usuarios}
                      setUsuarios={setUsuarios}
                      token={token}
                    />
                  </Col>
                </Col>

                <Col md="12">
                  {submitAlert.text && (
                    <Alert
                      title={submitAlert.title}
                      type={submitAlert.type}
                      text={submitAlert.text}
                      closable={submitAlert.closable}
                    />
                  )}
                  <ButtonWithLoading
                    text="Guardar"
                    submit={submit}
                    loading={equipoCreate.loading}
                    pullRight
                  />
                </Col>
              </Row>
            </Box>
          </Col>
        </Row>
      </Loader>
    </Content>
  );
};
